import { render, staticRenderFns } from "./PackageLifeCycle.vue?vue&type=template&id=6ba7bea1&"
import script from "./PackageLifeCycle.vue?vue&type=script&lang=js&"
export * from "./PackageLifeCycle.vue?vue&type=script&lang=js&"
import style0 from "./PackageLifeCycle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageLifeCycle.vue"
export default component.exports